import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectorRef} from '@angular/core';
import * as _ from 'underscore';
import moment from 'moment';
import {BaseChartDirective} from 'ng2-charts';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { filter } from 'lodash';
import { plugins } from 'chart.js/dist/core';

@Component({
    selector: 'app-entity-ccr-exe-chart',
    templateUrl: './entity-ccr-exe-chart.component.html',
    styleUrls: ['./entity-ccr-exe-chart.component.scss'],
    standalone: false
})
export class EntityCcrExeChartComponent implements OnInit, OnChanges {

    @Input()
    entityCcrExeChartData: any[];

    @Input()
    entityCcrExeChartDataSimu: any[];

    @Input()
    maxCcrChartAxis?: string;

    @ViewChild(BaseChartDirective, {static: true}) chart: BaseChartDirective;

    public lineChartOptions: any = {
        // We use these empty structures as placeholders for dynamic theming.
        responsive: true,
        maintainAspectRatio: false,
        font: {
            size: 11
        },
        scales: {
            x: {
                type: 'time',
                time: {
                    displayFormats: {
                        quarter: 'MMM YYYY'
                    }
                },
                grid: {
                    display: false
                },
                ticks: {
                    font: {
                        size: 11
                    }
                },
            },
            y: {
                position: 'left',
                min: 0,
                max: 250,
                grid: {
                    display: false
                },
                ticks: {
                    stepSize: 25,
                    padding: 5,
                    font: {
                        size: 11
                    }
                }
            },
            y1: {
                position: 'right',
                grid: {
                    display: false,
                    drawTicks: false
                },
                ticks: {
                    display: false
                }
            }
        },
        plugins: {
            legend: {
                display: true,
                labels: {
                    filter: (legendItem: any) => legendItem.text !== undefined
                },
                position: 'right',
                align: 'center',
            },
        },
    };

/*     public chartOptions: any = {
        name: 'entityCcrExeChart',
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 0,
                right: 50,
                top: 0,
                bottom: 0
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                distribution: 'linear',
                time: {
                    unit: 'month',
                    stepSize: 1,
                    tooltipFormat: 'll',
                    displayFormats: {
                        month: 'MMM YYYY'
                    }
                },
                gridLines: {
                    drawOnChartArea: false,
                    tickMarkLength: 3
                },
                ticks: {
                    fontSize: 11
                }
            }, {
                position: 'top',
                ticks: {
                    display: false
                },
                gridLines: {
                    display: false,
                    drawTicks: false
                }
            }],
            yAxes: [{
                position: 'left',
                gridLines: {
                    drawOnChartArea: false,
                    tickMarkLength: 3
                },
                ticks: {
                    min: 0,
                    max: 250,
                    stepSize: 25,
                    padding: 5,
                    fontSize: 11
                }
            }, {
                position: 'right',
                ticks: {
                    display: false
                },
                gridLines: {
                    display: false,
                    drawTicks: false
                }
            }]
        }
    }; */
    //public chartLabels: number[] = [0, 0.5, 1, 2, 3, 4, 5, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 39, 42, 45, 48, 51, 54, 57, 60, 63, 66,
    //    69, 72, 75, 78, 81, 84, 87, 90, 93, 96, 99, 102, 105, 108, 111, 114, 117, 120];
    public chartLabels: number[] = [0, 0.5, 1, 2, 3, 4, 5, 6, 9, 12];
    public dateFormatLabels: Date[] = [];
    public chartType = 'line';
    
    public chartLegend = true;  


    public chartData: any[] = [];
    public chartDataSimu: any[] = [];

    public fillFor100And200: any[] = [{
        fill: 'start',
        hidden: true,
        lineTension: 0,
        borderWidth: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
        data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
            100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100]
    }, {
        fill: 'start',
        hidden: true,
        lineTension: 0,
        borderWidth: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
        data: [200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
            200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200]
    }];

    colorArray: any[] = [];

    fillColors = [{
        backgroundColor: '#fbe5e9',
        hoverBackgroundColor: '#fbe5e9',
        borderColor: '#f8d3da',
        hoverBorderColor: '#fbe5e9'
    }, {
        backgroundColor: '#fbebcb',
        hoverBackgroundColor: '#fbebcb',
        borderColor: '#fae4b8',
        hoverBorderColor: '#fbebcb'
    }];
    colors = [{
        backgroundColor: '#c98de3',
        hoverBackgroundColor: '#c98de3',
        borderColor: '#c98de3',
        hoverBorderColor: '#c98de3'
    }, {
        backgroundColor: '#435B40',
        hoverBackgroundColor: '#435B40',
        borderColor: '#435B40',
        hoverBorderColor: '#435B40'
    }, {
        backgroundColor: '#c84a43',
        hoverBackgroundColor: '#c84a43',
        borderColor: '#c84a43',
        hoverBorderColor: '#c84a43'
    }, {
        backgroundColor: '#e62c84',
        hoverBackgroundColor: '#e62c84',
        borderColor: '#e62c84',
        hoverBorderColor: '#e62c84'
    }, {
        backgroundColor: '#635BCD',
        hoverBackgroundColor: '#635BCD',
        borderColor: '#635BCD',
        hoverBorderColor: '#635BCD'
    }, {
        backgroundColor: '#884a49',
        hoverBackgroundColor: '#884a49',
        borderColor: '#884a49',
        hoverBorderColor: '#884a49'
    }, {
        backgroundColor: '#219113',
        hoverBackgroundColor: '#219113',
        borderColor: '#219113',
        hoverBorderColor: '#219113'
    }, {
        backgroundColor: '#2374a0',
        hoverBackgroundColor: '#2374a0',
        borderColor: '#2374a0',
        hoverBorderColor: '#2374a0'
    }];

    public Chart: any;

    constructor(private cdr: ChangeDetectorRef) {
    }

    ngOnChanges(changes: SimpleChanges) {
        //if (!changes.maxCcrChartAxis) {
        //    return;
        //}

        this.createDateFormatLabels();
        if (this.entityCcrExeChartDataSimu && this.entityCcrExeChartDataSimu.length > 0) {
            this.rotateDataSimu();
        } else {
            this.rotateData();
        }
        this.getCcrYAxis();
    }

    ngOnInit() {
    }

    public createDateFormatLabels() {
        let startDate = moment();
        if (this.entityCcrExeChartData && this.entityCcrExeChartData.length > 0) {
            startDate = moment(this.entityCcrExeChartData[0].timeStepDate);
        }
        if (this.entityCcrExeChartDataSimu && this.entityCcrExeChartDataSimu.length > 0) {
            const startDateSimu = moment(this.entityCcrExeChartData[0].timeStepDate);
            if (startDateSimu.isBefore(startDate)) {
                startDate = startDateSimu;
            }
        }

        this.dateFormatLabels = _.map(this.chartLabels, x => {
            if (x === 0.5) {
                return startDate.clone().add(15, 'days').toDate();
            }
            return startDate.clone().add(x, 'months').toDate();
        });
    }

    public rotateData() {
        if (!this.entityCcrExeChartData || this.entityCcrExeChartData.length <= 0) {
            return;
        }
        this.chartData = [];
        const counterPartyList = _.groupBy(this.entityCcrExeChartData, 'counterParty');

        for (const key of Object.keys(counterPartyList)) {
            let data = _.map(counterPartyList[key], x => x.ccr.toFixed(2));
            if (this.chartLabels.length !== data.length) {
                data = this.fixMissingTimesteps(counterPartyList[key]);
            }

            this.chartData.push({
                label: key,
                fill: false,
                lineTension: 0.5,
                borderWidth: 1.2,
                pointRadius: 2,
                pointHoverRadius: 3,
                data: data
            });
        }
        this.colorArray = this.colors.slice(0, this.chartData.length);
        this.colorArray.push(this.fillColors[0]);
        this.colorArray.push(this.fillColors[1]);
        this.chartData.push(this.fillFor100And200[0]);
        this.chartData.push(this.fillFor100And200[1]);
    }

    public rotateDataSimu() {
        let colorOffset = 0;
        if (this.entityCcrExeChartData && this.entityCcrExeChartData.length > 0) {
            this.chartData = [];
            const counterPartyList = _.groupBy(this.entityCcrExeChartData, 'counterParty');

            for (const key of Object.keys(counterPartyList)) {
                let data = _.map(counterPartyList[key], x => x.ccr.toFixed(2));
                if (this.chartLabels.length !== data.length) {
                    data = this.fixMissingTimesteps(counterPartyList[key]);
                }

                this.chartData.push({
                    label: key,
                    fill: false,
                    lineTension: 0.5,
                    borderWidth: 1.2,
                    pointRadius: 2,
                    pointHoverRadius: 3,
                    data: data
                });
            }
            this.colorArray = this.colors.slice(0, this.chartData.length);
            colorOffset += this.chartData.length;
        }
        const counterPartyListSimu = _.groupBy(this.entityCcrExeChartDataSimu, 'counterParty');

        for (const key of Object.keys(counterPartyListSimu)) {
            let data = _.map(counterPartyListSimu[key], x => x.ccr.toFixed(2));
            if (this.chartLabels.length !== data.length) {
                data = this.fixMissingTimesteps(counterPartyListSimu[key]);
            }

            this.chartData.push({
                label: key + '(simu)',
                fill: false,
                lineTension: 0.5,
                borderWidth: 1.2,
                pointRadius: 2,
                pointHoverRadius: 3,
                data: data
            });
        }
        this.colorArray.push(...this.colors.slice(colorOffset, this.chartData.length));

        this.colorArray.push(this.fillColors[0]);
        this.colorArray.push(this.fillColors[1]);
        this.chartData.push(this.fillFor100And200[0]);
        this.chartData.push(this.fillFor100And200[1]);
    }


    public fixMissingTimesteps(data: any[]): any[] {
        return _.map(this.chartLabels, x => {
            if (_.any(data, item => item.timeStep === x)) {
                return _.find(data, y => y.timeStep === x).ccr.toFixed(2);
            }
            return 0;
        });
    }

    public getCcrYAxis() {
        // Check if scales.y exists and is an array before accessing its properties
        if (!this.lineChartOptions?.scales?.y || !Array.isArray(this.lineChartOptions.scales.y) || this.lineChartOptions.scales.y.length === 0) {
            return;
        }
        
        // Access the first y-axis (left side)
        const yScale = this.lineChartOptions.scales.y[0];
        
        if (this.maxCcrChartAxis && (this.maxCcrChartAxis === '500' || this.maxCcrChartAxis === '250')) {
            yScale.max = +this.maxCcrChartAxis;
            if (yScale.ticks) {
                yScale.ticks.stepSize = this.maxCcrChartAxis === '500' ? 50 : 25;
            }
        } else {
            const ccrList = [];
            if (this.entityCcrExeChartData && this.entityCcrExeChartData.length > 0) {
                ccrList.push(...this.entityCcrExeChartData);
            }
            if (this.entityCcrExeChartDataSimu && this.entityCcrExeChartDataSimu.length > 0) {
                ccrList.push(...this.entityCcrExeChartDataSimu);
            }
            
            // Check if we have any data before calculating max
            if (ccrList.length === 0) {
                return;
            }
            
            let maxCcr = Math.max(...ccrList.map(x => x.ccr.toFixed(0)));

            maxCcr = +this.getAddFivePercent(maxCcr).toFixed(0);
            yScale.max = maxCcr;
            const numberOfSteps = 10;
            if (yScale.ticks) {
                yScale.ticks.stepSize = this.getNearestBaseValue(maxCcr , numberOfSteps);
            }
        }
        this.reloadChart();
        // this.refreshChart();
    }

    public getAddFivePercent(max: number): number {
        return max + ((max * 5) / 100);
    }

    public getNearestBaseValue(maxCcr: number, numberOfSteps: number): number {
        const stepValue = maxCcr / numberOfSteps;
        const length = maxCcr.toString().length;
        let str = '1';
        for (let i = 1; i < length - 1; i++) {
            str += '0';
        }

        return Math.ceil(stepValue / (+str)) * (+str);
    }

    /*
    private refreshChart() {
        this.chartOptions = Object.assign({}, this.chartOptions);
        if (this.chart !== undefined && this.chart.ctx !== undefined) {
            this.cdr.detectChanges();
            this.chart.ngOnDestroy();
            this.chart.chart = this.chart.getChartBuilder(this.chart.ctx);
        }
    }
    */

    /*
     * Redraw the whole chart when the input data are updated.
     *
     * We cannot use refreshChart(), b/c when we remove a line it only sets its data to zero!
     */
    public reloadChart() {
        if (this.chart !== undefined && this.chart.chart) {
            this.chart.chart.destroy();
          //  this.chart.chart = 0;

            this.chart.datasets = this.chartData;
         //   this.chart.labels = this.dateFormatLabels;
            this.chart.options = this.lineChartOptions;
            this.chart.legend = this.chartLegend;
         //   this.chart.chartType = this.chartType;
         //   this.chart.colors = this.colorArray;
         //   this.chart.ngOnInit();
        }
    }

}
